export enum LabRequisitionStatus 
{
    Pending = 1,
    Cancelled = 2,
    Completed = 3, 
    Shipped = 4, 
    PartiallyShipped=5 
}
  